import {
  WeaveAssistantLocationSetting_Hours,
  WeaveAssistantLocationSetting_WeaveAssistantAdvancedSettings,
  WeaveAssistantLocationSetting_WeaveAssistantGeneralSettings,
  WeaveAssistantLocationSetting_WeaveAssistantOfficeSettings,
  WeaveAssistantLocationSetting_WeaveAssistantPaymentSettings,
  WeaveAssistantLocationSetting_WeaveAssistantPhoneLocationSetting,
  WeaveAssistantLocationSetting_WeaveAssistantSmsLocationSetting,
} from '@weave/schema-gen-ts/dist/schemas/messaging/settings/v1/settings.pb';

export const DEFAULT_ADVANCED_SETTINGS: WeaveAssistantLocationSetting_WeaveAssistantAdvancedSettings = {
  trainingDocumentBuckets: [],
  trainingNotes: [],
};

export const DEFAULT_DEBOUNCE_DELAY = 750; // milliseconds

export const DEFAULT_GENERAL_SETTINGS: WeaveAssistantLocationSetting_WeaveAssistantGeneralSettings = {
  businessAddress: '',
  businessWebsite: '',
  cancellationScript: '',
  emergencyScript: '',
  faqsLink: '',
  newPatientFormLinkEnglish: '',
  newPatientFormLinkSpanish: '',
};

export const DEFAULT_OFFICE_SETTINGS: WeaveAssistantLocationSetting_WeaveAssistantOfficeSettings = {
  officeAmenities: [],
  amenityDetails: '',
};

export const DEFAULT_PAYMENT_SETTINGS: WeaveAssistantLocationSetting_WeaveAssistantPaymentSettings = {
  paymentMethods: [],
  insuranceDetails: '',
  paymentDetails: '',
};

export const DEFAULT_PHONE_SETTINGS: WeaveAssistantLocationSetting_WeaveAssistantPhoneLocationSetting = {
  enableWeaveAssistantPhone: false,
  assistantFunctions: [],
};

export const DEFAULT_SMS_SETTINGS: WeaveAssistantLocationSetting_WeaveAssistantSmsLocationSetting = {
  enableWeaveAssistantSms: false,
  assistantFunctions: [],
  contactTypes: [],
  hours: WeaveAssistantLocationSetting_Hours.ALL,
  hourTypes: [],
};

export const DEFAULT_WEAVE_ASSISTANT_ENABLED = false;

const WEAVE_ASSISTANT_FIELD_MASK_PATH_PREFIX_BASE = 'weaveAssistantLocationSetting.';

export const WEAVE_ASSISTANT_FIELD_MASK_PATH_PREFIX = {
  ADVANCED_SETTINGS: WEAVE_ASSISTANT_FIELD_MASK_PATH_PREFIX_BASE + 'advancedSettings.',
  GENERAL_SETTINGS: WEAVE_ASSISTANT_FIELD_MASK_PATH_PREFIX_BASE + 'generalSettings.',
  OFFICE_SETTINGS: WEAVE_ASSISTANT_FIELD_MASK_PATH_PREFIX_BASE + 'officeSettings.',
  PAYMENT_SETTINGS: WEAVE_ASSISTANT_FIELD_MASK_PATH_PREFIX_BASE + 'paymentSettings.',
  PHONE_SETTINGS: WEAVE_ASSISTANT_FIELD_MASK_PATH_PREFIX_BASE + 'phoneSettings.',
  SMS_SETTINGS: WEAVE_ASSISTANT_FIELD_MASK_PATH_PREFIX_BASE + 'smsSettings.',
  WEAVE_ASSISTANT: WEAVE_ASSISTANT_FIELD_MASK_PATH_PREFIX_BASE,
};
